const MusicDropIcon = () => {
    return(
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5834 43.75C13.4783 43.75 12.4185 43.311 11.6371 42.5296C10.8557 41.7482 10.4167 40.6884 10.4167 39.5833V6.25H29.1667L39.5834 16.6667V39.5833C39.5834 40.6884 39.1444 41.7482 38.363 42.5296C37.5816 43.311 36.5218 43.75 35.4167 43.75H14.5834Z" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M27.0834 6.25V18.75H39.5834" stroke="#1E1E1E" stroke-width="2" stroke-linejoin="round"/>
<path d="M22.9167 37.4997C24.0673 37.4997 25 36.5669 25 35.4163C25 34.2657 24.0673 33.333 22.9167 33.333C21.7661 33.333 20.8334 34.2657 20.8334 35.4163C20.8334 36.5669 21.7661 37.4997 22.9167 37.4997Z" stroke="#1E1E1E" stroke-width="2"/>
<path d="M25 35.4167V25L29.1667 29.1667" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

    )
}

export default MusicDropIcon